







import { Vue } from "vue-property-decorator";
export default Vue.extend({
  props: {
    message: {
      default: " Oups, une erreur Mobi !",
      type: String
    }
  }
});
